import { Component } from "../component"
import Vimeo from "@vimeo/player"

export class VideoPlayer extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      playing: "-playing",
    }

    this.videoType = this.$el.dataset.type
  }

  ui() {
    return {
      element: ".video-player-element",
      elementLifeStyle: ".section-lifestyle-images-video",
      videoElement: ".js-autoplay-video",
      hoverVideoElement: ".js-video-hover-played",
      vimeoElement: ".video-player-vimeo",
      poster: ".video-player-poster",
      button: ".video-player-button",
      productCard: ".product-card",
    }
  }

  initVideoObservers() {
    const { playing } = this.dynamicClasses

    const videos = [
      ...document.querySelectorAll(this.ui().elementLifeStyle),
      ...document.querySelectorAll(this.ui().videoElement),
    ]

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const video = entry.target
        if (entry.isIntersecting) {
          if (video.paused) {
            video.play()
            video.classList.add(playing)
          }
        } else {
          if (!video.paused) {
            video.pause()
            video.classList.remove(playing)
            video.currentTime = 0
          }
        }
      })
    }

    const videoObserver = new IntersectionObserver(handleIntersection, {
      threshold: 0.0001,
      rootMargin: "600px",
    })

    videos.forEach((video) => {
      if (video.tagName.toLowerCase() === "video") {
        videoObserver.observe(video)
      }
    })
  }

  initHoverVideos() {
    const hoverVideo = this.$el.querySelector(this.ui().hoverVideoElement)
    if (!hoverVideo) return

    const parentCard = this.$el.closest(this.ui().productCard)
    if (!parentCard) return

    let isVideoLoaded = false
    let videoTimeout
    let isTouch = false

    const playVideo = () => {
      hoverVideo.classList.add(this.dynamicClasses.playing)

      hoverVideo.play().catch(() => {
        hoverVideo.play()
      })

      if (isTouch) {
        if (videoTimeout) {
          clearTimeout(videoTimeout)
        }
        videoTimeout = setTimeout(() => {
          handleLeave()
        }, 20000)
      }
    }

    const handleEnter = (fromTouch = false) => {
      isTouch = fromTouch

      if (!isVideoLoaded) {
        hoverVideo.load()
        isVideoLoaded = true

        hoverVideo.addEventListener(
          "loadeddata",
          () => {
            playVideo()
          },
          { once: true }
        )
      } else {
        playVideo()
      }
    }

    const handleLeave = () => {
      if (videoTimeout) {
        clearTimeout(videoTimeout)
      }
      hoverVideo.pause()
      hoverVideo.currentTime = 0
      hoverVideo.classList.remove(this.dynamicClasses.playing)
    }

    // Desktop events
    parentCard.addEventListener("mouseenter", () => handleEnter(false))
    parentCard.addEventListener("mouseleave", () => {
      setTimeout(handleLeave, 300)
    })

    // Mobile touch events
    parentCard.addEventListener("touchstart", () => handleEnter(true))
  }

  setupVimeo() {
    const { vimeoElement, poster, button } = this.$ui
    const { playing } = this.dynamicClasses

    const player = new Vimeo(vimeoElement.id, {
      url: vimeoElement.dataset.videoUrl,
      controls: false,
      responsive: true,
      autoplay: true,
    })
    if (poster) {
      poster.addEventListener("click", () => {
        player.pause()
        this.$el.classList.remove(playing)
      })
    }

    player.ready().then(() => {
      player.play().catch(() => {
        console.log("Autoplay failed")
      })
      this.$el.classList.add(playing)
    })

    button.addEventListener("click", () => {
      player.play()
      this.$el.classList.add(playing)
    })
  }

  setupRegularVideo() {
    const { element, vimeoElement, poster, button } = this.$ui
    const { playing } = this.dynamicClasses
    let video = element

    if (!element && !vimeoElement) return

    if (this.videoType === "vimeo") {
      const player = new Vimeo(vimeoElement.id, {
        url: vimeoElement.dataset.videoUrl,
        controls: false,
        responsive: true,
      })
      video = player
    }

    video.addEventListener("play", () => {
      button.style.display = "none"
    })

    button.addEventListener("click", () => {
      video.play()
      this.$el.classList.add(playing)
    })

    if (poster) {
      poster.addEventListener("click", () => {
        video.pause()
        this.$el.classList.remove(playing)
        button.style.display = "block"
      })
    }
  }

  created() {
    this.initVideoObservers()
    this.initHoverVideos()

    if (this.videoType === "vimeo") {
      this.setupVimeo()
    } else {
      this.setupRegularVideo()
    }
  }
}
